/** Live checkout destination for every buy button on the page. */
export const CHECKOUT_URL = 'https://the-teachers-jazz.impultienda.ar/checkout'
